import React, { createContext, useContext, useState, useEffect } from 'react';

type Strategy = 'donchian' | 'ualgo';

interface StrategyContextType {
  strategy: Strategy;
  setStrategy: (s: Strategy) => void;
  strategyLabel: string;
}

const StrategyContext = createContext<StrategyContextType>({
  strategy: 'donchian',
  setStrategy: () => {},
  strategyLabel: 'Donchian Breakout',
});

const LABELS: Record<Strategy, string> = {
  donchian: 'Donchian Breakout',
  ualgo: 'UAlgo Trend',
};

export function StrategyProvider({ children }: { children: React.ReactNode }) {
  const [strategy, setStrategyState] = useState<Strategy>(() => {
    const saved = localStorage.getItem('activeStrategy');
    return (saved === 'ualgo' ? 'ualgo' : 'donchian') as Strategy;
  });

  const setStrategy = (s: Strategy) => {
    setStrategyState(s);
    localStorage.setItem('activeStrategy', s);
  };

  return (
    <StrategyContext.Provider value={{ strategy, setStrategy, strategyLabel: LABELS[strategy] }}>
      {children}
    </StrategyContext.Provider>
  );
}

export function useStrategy() {
  return useContext(StrategyContext);
}

export default StrategyContext;
